import { Grid, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useMessageChurchMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Screen from '../../components/fragments/Screen';
import Form from '../../components/utilities/Form';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    title: Yup.string().required().min(3).label('Subject'),
    message: Yup.string().min(10).required().label('Message'),
});

export default function MessageChurchScreen() {
    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();

    const [messageChurch, { isLoading }] = useMessageChurchMutation();

    return (
        <Screen title="Send Message">
            <Grid item>
                <Form
                    validationSchema={validate}
                    initialValues={{ title: '', message: '' }}
                    onSubmit={async ({ title, message }) => {
                        const { error, data } = await messageChurch({
                            title,
                            message,
                        });

                        errorSnackbar(error, enqueueSnackbar);

                        if (data) {
                            enqueueSnackbar('Message sent');
                            navigate(-1);
                        }
                    }}
                >
                    <Typography className="fw-bold text-centerx text-uppercasex mb-2">
                        Send a private message to your church admin/Pastor on
                        Prayer Requests, Thanksgiving Request, Announcements
                        etc. (Once your church admin responds, you will get the
                        response in your email)
                    </Typography>
                    <FormikInput name="title" label="Subject" />
                    <FormikInput
                        name="message"
                        rows={5}
                        label="Message"
                        multiline
                    />
                    <FormikButton loading={isLoading} variant="contained">
                        Send
                    </FormikButton>
                </Form>
            </Grid>
        </Screen>
    );
}
